const QUERY = `mutation MarkNotificationRead($notificationId: ID!) {
  markNotificationRead(notificationId: $notificationId) {
    success
  }
}`;

export const markNotificationRead = {
  query: QUERY,
};
